module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 12
// module chunks = 0 1